import type { BomDocumentComposition, BomDocumentGroup } from '../../gql';

import {
    randBoolean,
    randNumber,
    randRecentDate,
    randSentence,
    randUuid,
} from '@ngneat/falso';

const mockBomDocumentComposition = (
    override?: Partial<BomDocumentComposition>
): BomDocumentComposition => ({
    compositionIndex: randNumber(),
    styleOptions: [],
    bomUsages: [],
    ...override,
    ['__typename']: 'BomDocumentComposition',
});

const mockGroupState = (): BomDocumentGroup['groupState'] => {
    const groupStates = ['VALID', 'INVALID', 'MIXED']; // No idea what these values can be, BE has it as a string...
    const randomIndex = randNumber({ min: 0, max: 2 });
    return groupStates[randomIndex];
};

const mockBomDocumentGroup = (
    override?: Partial<BomDocumentGroup>
): BomDocumentGroup => {
    const amountOfCompositions = randNumber({ min: 1, max: 3 });
    return {
        bomDocumentGroupPublicId: randUuid(),
        styleNumber: randNumber(),
        supplierNumber: randNumber().toString(),
        updatedDate: randRecentDate(),
        updatedBy: randUuid(),
        bomDocumentCompositions: Array.from(
            { length: amountOfCompositions },
            () => mockBomDocumentComposition()
        ),
        groupState: mockGroupState(),
        groupVersion: randNumber(),
        comment: randBoolean() ? randSentence() : undefined,
        ...override,
        ['__typename']: 'BomDocumentGroup',
    };
};

export { mockGroupState, mockBomDocumentGroup, mockBomDocumentComposition };
